import { CREATE_INSTRUCTOR, GET_INSTRUCTOR, SET_ALL_INSTRUCTOR, SET_ALL_INSTRUCTOR_SELECT, UPDATE_INSTRUCTOR } from "../../reducerTypes"

const initialState = {
  currentInstuctor: {},
  instructorList: [],
  selectData:[]
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_INSTRUCTOR:
      return{
        ...state,
        instructorList: action.payload
      }
    case CREATE_INSTRUCTOR:
      return{
        ...state,
        currentInstuctor: action.payload
      }
    case GET_INSTRUCTOR: 
    return{
      ...state,
      currentInstuctor: action.payload
    }
    case UPDATE_INSTRUCTOR: 
    return{
      ...state,
      currentInstuctor: action.payload
    }
    case SET_ALL_INSTRUCTOR_SELECT:
      const contentData = action.payload && action.payload.content ? action.payload.content : [];
      const selectData = [];
      contentData.map((data)=>{
        selectData.push({
          value: data.id,
          label: `${data.prefix ? data.prefix + ' ' : ''}${data.name}`
        })
        return data
      });
      return{
        ...state,
        selectData: selectData
      }
    default:
      return state
  }
}

export default userReducer
